import React, { Component } from 'react'
import PageBuilderAddElements from './PageBuilderAddElements'
import PageBuilderAddElements2 from './PageBuilderAddElements2'
import PageBuilderHeader from './PageBuilderHeader'
import PageBuilderMain from './PageBuilderMain'
import { formBuilderGroups, FormBuilderObjects } from '../variables/formBuilderData'
import { widgetsList, widgetsGroups } from '../variables/widgetsList'
import inputComponents from '../components/inputs/inputComponents'
import WidgetComponents from '../components/widgets/WidgetComponents'
import ButtonAnimated from '../components/buttons/ButtonAnimated'
import HttpServices from '../utils/Http.services'
import Modal from '../components/Modal'
import { translate } from '../utils/useful'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../stores/actionsList';
import PageViewer from './PageViewer'
// import { FormBuilderObjects } from '../variables/formBuilderData';

class PagesStackNavigator extends Component {
    state = {
        type: 'dashboard',
        componentsInfo: {
            form: { object: FormBuilderObjects, groups: formBuilderGroups, components: inputComponents },
            dashboard: { object: widgetsList, groups: widgetsGroups, components: WidgetComponents },
        },
    }

    componentDidMount() {
        this.init()

        // console.log(this.props.baseUrl)
        // console.log(this.props.windowData)

        if (this.props.setHeader) {
            this.props.setHeader({
                // 'toolbar': null,
                'showToolbar': false,
                topHeaderComponent: this.topHeaderComponent,
                headerIdentityComponent: this.headerIdentityComponent,
                backAction: () => { this.props.changePage(''); console.log('backkkkkkkkkkkkkkkk') }

            })
        }
    }
    componentDidUpdate(prevProps) {
        if (this.props.windowData?.path[this.props.baseUrl?.length] != prevProps.windowData?.path[this.props.baseUrl?.length]) {
            this.init()
        }
    }
    // init = () => {
    //     let _id = this.props.windowData?.path[this.props.baseUrl?.length]
    //     console.log('get Page', this.props.applet)
    //     // console.log(_id)
    //     if (_id != "new" && _id != null) {

    //         // GET PAGE
    //         HttpServices.request('getFrame', { _id: _id }, (fetchResult, fetchError) => {
    //             console.log('fethcresult1-', fetchResult.info)
    //             this.setState({ _id: _id, initData: fetchResult.info.page, name: fetchResult.info.name }, () => {

    //                 // this.props.setHeader("dummy",1)
    //             })
    //         })
    //     }
    //     else if (this.props.applet?.page) {
    //         HttpServices.request('getFrame', { _id: this.props.applet.page?._id }, (fetchResult, fetchError) => {
    //             console.log('fethcresult1-', fetchResult.info)
    //             this.setState({ _id: _id, initData: fetchResult.info.page, name: fetchResult.info.name }, () => {
    //                 if (this.props.setHeader) {
    //                     this.props.setHeader("dummy", 1)
    //                 }
    //             })
    //         })
    //         // this.setState({ _id: this.props.applet?.page._id, initData: this.props.applet?.page.page, name: this.props.applet?.page.name }, () => {
    //         //     this.props.setHeader("dummy", 1)
    //         //     console.log('this.props.applet?.page', this.props.applet?.page)
    //         // })
    //     }
    // }
    init() {

        this.setState({ view: false }, () => {
            this.setState({ view: true }, () => {


                let _id = this.props.windowData?.path[this.props.baseUrl?.length]
                if (_id != "new" && _id != null) {
                    // GET PAGE
                    HttpServices.request('getFrame', { _id: _id }, (fetchResult, fetchError) => {

                        if (fetchError || !fetchResult || !fetchResult.info) {
                            return
                        }

                        this.setState({ _id: _id, initData: fetchResult.info.page, name: fetchResult.info.name, page: fetchResult?.info }, () => {
                            if (this.props.setHeader) {

                                this.props.setHeader("dummy", 1)
                            }
                        })

                        if (fetchResult?.info?.config?.fetches) {
                            this.getSingleContent(fetchResult?.info)
                        }
                    })
                }
                else if (this.props.applet?.page) {

                    HttpServices.request('getFrame', { _id: this.props.applet.page?._id }, (fetchResult, fetchError) => {

                        if (fetchError || !fetchResult || !fetchResult.info) {
                            return
                        }

                        this.setState({ _id: _id, initData: fetchResult.info.page, name: fetchResult.info.name, page: fetchResult?.info }, () => {
                            if (this.props.setHeader) {

                                this.props.setHeader("dummy", 1)
                            }
                        })

                        if (fetchResult?.info?.config?.fetches) {
                            this.getSingleContent(fetchResult?.info)
                        }
                    })
                    //         HttpServices.request('getFrame', { _id: this.props.applet.page?._id }, (fetchResult, fetchError) => {
                    //             console.log('fethcresult1-', fetchResult.info)
                    //             this.setState({ _id: _id, initData: fetchResult.info.page, name: fetchResult.info.name }, () => {
                    //                 if (this.props.setHeader) {
                    //                     this.props.setHeader("dummy", 1)
                    //                 }
                    //             })
                    //         })
                    //         // this.setState({ _id: this.props.applet?.page._id, initData: this.props.applet?.page.page, name: this.props.applet?.page.name }, () => {
                    //         //     this.props.setHeader("dummy", 1)
                    //         //     console.log('this.props.applet?.page', this.props.applet?.page)
                    //         // })
                }
                if (this.props.setHeader) {
                    this.props.setHeader({
                        'toolbar': null,
                        'showToolbar': false,
                        topHeaderComponent: this.topHeaderComponent,
                        headerIdentityComponent: this.headerIdentityComponent,
                        backAction: () => this.props.changePage('pages')
                    })
                }

            })
        })

    }



    setData = (key, value, reference, cb) => {
        if (reference == 'PageBuilder') {
            this.setState({ [key]: value }, () => {
                if (cb) {
                    cb()
                }
            })
        }
        else {
            if (this.props.setData) {
                this.props.setData(key, value, reference, () => {

                })
            }
        }
    }

    topHeaderComponent = () => {
        return (
            <div className='flexc'>
                <div className='px-2'>
                    <PageBuilderAddElements type={this.state.type} componentsInfo={this.state.componentsInfo[this.state.type]} onDragStartAction={this.onDragStartAction} applet={this.props.applet} />
                </div>

                <ButtonAnimated
                    iconwidth='24px'
                    onClick={this.savePage}
                    title='Save'
                    icon='/assets/icons/plus-white.svg'
                    textColor={this.props.colors?.iconInvert ? '#fff' : '#000'}
                    invert={!this.props.colors?.iconInvert}
                    bg={this.props.colors?.iconInvert ? '#000' : '#fff'}
                // border={''}
                />

            </div>
            // <button className='br-20 px-2 py-1' style={{backgroundColor:'#fff'}}>
            //     <p>Save</p>
            // </button>
        )
    }
    headerIdentityComponent = () => {
        return (
            <div className='' >
                <input onChange={(e) => this.setName(e.target.value)} value={this.state.name} className={' ' + this.props.colors?.iconInvert ? 'lightPlaceholder' : 'darkPlaceholder'} style={{ fontSize: '18px', backgroundColor: 'transparent', border: 'none', color: this.props.colors.textColor }} placeholder={translate('insert name ...')} />
            </div>
            // <button className='br-20 px-2 py-1' style={{backgroundColor:'#fff'}}>
            //     <p>Save</p>
            // </button>
        )
    }
    setName = (value) => {
        this.setState({ name: value })
    }



    onDragStartAction = (e) => {
        this.PageBuilderMain.onDragStartAction(e)
    }

    render() {

        // let background = this.props.colors ? `linear-gradient(90deg, ${this.props.colors?.primaryColor}, ${this.props.colors?.secondaryColor})` : 'linear-gradient(to right, #5856D6, #7D7AFF)'


        return (
            <div className='w-100 d-flex window-content-radius h-100 ' style={{ background: '#fff' }}>
                <div className='w-100 h-100'>

                    <div className='w-100 h-100'>

                        <PageViewer editMode={false} functionsHandler={this.props.functionsHandler} setHeader={this.props.setHeader}
                            params={this.state.params} initData={this.state.initData} width={this.props.width} height={this.props.height} colors={this.props.colors} changeWindowLink={this.props.changeWindowLink} pageChangePage={this.props.pageChangePage}
                            windowData={this.props.windowData} route={this.props.rootUrl} applet={this.props.applet}
                            connection={this.props.connection} user={this.props.user} setUser={this.props.setUser}
                            addNotif={this.props.addNotif} history={this.props.history} location={this.props.location}
                            goToHub={this.props.goToHub} language={this.props.language} changeWindow={this.props.changeWindow}
                        />
                        {/* <PageBuilderMain userView={this.props.userView} baseUrl={this.props.baseUrl} windowData={this.props.windowData} functionsHandler={this.props.functionsHandler} setHeader={this.props.setHeader} changeWindow={this.props.changeWindow} params={this.state.params} initData={this.state.initData} componentsInfoForm={this.state.componentsInfo['form']} type={this.state.type} componentsInfo={this.state.componentsInfo[this.state.type]} ref={el => this.PageBuilderMain = el} width={this.props.width} height={this.props.height} colors={this.props.colors} changeWindowLink={this.props.changeWindowLink} pageChangePage={this.props.pageChangePage} applet={this.props.applet} /> */}
                    </div>

                </div>
            </div>
        )
    }
}

const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PagesStackNavigator);